module.exports = __webpack_public_path__ + "static/media/as_item3_content.e909a3b7.png";